<template>
    <div>
        <v-container app :fluid="true" class="padding-top-0 padding-bootom-0 ">
            <v-row>
                <v-col cols="12" class="padding-top-0">
                    <v-card>                        
                        <v-card-title dark class="head-cart">
                            Nuevo pedido
                            <v-spacer></v-spacer>
                            <v-menu open-on-hover :close-on-content-click="true" offset-x >
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" text>
                                        <v-icon size="30" color="white">fas fa-cog</v-icon>
                                    </v-btn>
                                </template>
                                <v-card>
                                    <v-list>
                                        <v-list-item>
                                            <v-list-item-action>
                                                <v-switch 
                                                    ref="swithDirect"
                                                    v-model="isDirectSale" 
                                                    color="success"
                                                    @change="handleVerifyCash"
                                                ></v-switch>
                                            </v-list-item-action>
                                            <v-list-item-title>Venta directa</v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-card>
                            </v-menu>
                        </v-card-title>
                        <v-card-text class="pt-1 pb-1">
                            <v-container class="pt-1 pb-1">
                                <v-row>
                                    <v-col cols="5" class="pt-1 pb-2">
                                        <v-menu
                                            v-model="menuPickupDate"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                ref="pickup_date"
                                                v-model="pickup_date"
                                                label="Fecha de recojo"
                                                readonly
                                                clearable
                                                v-on="on"
                                                outlined
                                                hide-details
                                                dense
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker v-model="pickup_date" 
                                                @input="menuPickupDate = false" 
                                                no-title>
                                            </v-date-picker>
                                        </v-menu>
                                    </v-col>

                                    <v-col cols="7" class="pt-1 pb-2">
                                        <buyer source="sales"></buyer>
                                    </v-col>
                                </v-row>
                            </v-container>                            
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-text class="list-products-in-cart padding-top-0">
                            <v-list-item v-for="item in selectedProducts" :key="item.id" 
                                class="cart-item-product" 
                                two-line 
                                flat
                            >
                                <template>                                
                                    <v-list-item-content class="pt-1 pb-1">
                                        <v-list-item-title class="product-name" 
                                            @click="handleClickSettingItem(item)">
                                            <v-icon v-if="item.is_bonus"
                                                color="amber" size="18" class="mr-1">
                                                fas fa-gift
                                            </v-icon>
                                            <span>
                                                {{ item.name }}
                                            </span>
                                        </v-list-item-title>
                                        <v-list-item-subtitle v-if="item.discount_amount > 0" class="product-price">
                                            <span class="label-price-discounted">
                                                {{ item.base_price * item.quantity | currency('S/') }}
                                            </span>
                                            <span class="ml-2">{{ item.price | currency('S/') }}</span>
                                        </v-list-item-subtitle>
                                        <v-list-item-subtitle v-else class="product-price">
                                            {{ item.price | currency('S/') }}
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-action class="btn-quantity mt-2 mb-1">
                                        <span class="ml-4 mr-4 pb-1 product-quantity">{{ item.quantity }}</span>

                                        <v-btn x-small outlined @click="addItem(item)" dark color="green darken-3" :elevation="4" height="25" class="mr-1">
                                            <v-icon size="12" dark>fas fa-plus</v-icon>
                                        </v-btn>

                                        <v-btn x-small outlined @click="removeItem(item)" dark color="red darken-1" :elevation="4" height="25" class="mr-1">
                                            <v-icon size="12" dark>fas fa-minus</v-icon>
                                        </v-btn>

                                        <v-btn x-small outlined @click="deleteProduct(item)" dark color="grey darken-3" :elevation="4" height="25">
                                            <v-icon size="12" dark>fas fa-times</v-icon>
                                        </v-btn>

                                    </v-list-item-action>
                                </template>
                            </v-list-item>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-text class="pt-0">
                            <v-list-item class="cart-summary pl-0 pr-0">
                                <v-list-item-content class="pt-1 pb-1">
                                    <v-list-item-title class="amount-discount label-summary">
                                        Descuento
                                    </v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action class="btn-quantity amount-discount font-weight-black mt-2 mb-1">
                                    {{ discount | currency('S/')}}
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item class="cart-summary pl-0 pr-0">
                                <v-list-item-content class="pt-1 pb-1">
                                    <v-list-item-title class="label-summary">
                                        Subtotal
                                    </v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action class="btn-quantity font-weight-black mt-2 mb-1">
                                    {{ subtotal | currency('S/ ') }}
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item class="cart-summary pl-0 pr-0">
                                <v-list-item-content class="pt-1 pb-1">
                                    <v-list-item-title class="label-summary">
                                        IGV
                                    </v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action class="btn-quantity font-weight-black mt-2 mb-1">
                                    {{ amount_igv | currency('S/ ') }}
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item class="cart-summary pl-0 pr-0">
                                <v-list-item-content class="pt-1 pb-1">
                                    <v-list-item-title class="label-summary">
                                        Total
                                    </v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action class="btn-quantity font-weight-black mt-2 mb-1">
                                    {{ total | currency('S/ ') }}
                                </v-list-item-action>
                            </v-list-item>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <v-row v-if="isDirectSale">
                <v-col cols="12" class="padding-top-0 padding-bottom-0">
                    <v-btn block dark color="green darken-1" height="45" 
                        @click="handlePay()"
                        v-if="verifyPermission('pagar_pedido_pedido')">
                        Pagar
                    </v-btn>
                </v-col>
            </v-row>
            <v-row v-else>
                <v-col v-if="orderId == 0 && verifyPermission('ingresar_pedido_pedido')" 
                    cols="12" 
                    class="padding-top-0 padding-bottom-0"
                >
                    <template>
                        <v-row>
                            <v-col cols="12">
                                <v-btn  
                                    block 
                                    dark 
                                    color="green darken-1" 
                                    height="40" 
                                    @click="handleCreateOrder()"
                                    :disabled="press_register">
                                    Registrar pedido
                                </v-btn>
                            </v-col>
                            <!--
                            <v-col cols="6">
                                <v-btn  
                                    block 
                                    dark 
                                    color="blue darken-1" 
                                    height="40" 
                                    @click="handleCreateOrderWithPayment()">
                                    Registrar con pago
                                </v-btn>
                            </v-col>
                            -->
                        </v-row>
                    </template>                    
                </v-col>
                <v-col cols="12" v-else>
                    <v-btn block 
                        dark 
                        color="green darken-1" 
                        height="40" 
                        @click="handleUpdateOrder()">
                        Actualizar pedido
                    </v-btn>
                </v-col>
            </v-row>          
        </v-container>
        <setting-item ref="settingItem"></setting-item>
        <payment-form ref="paymentForm"/>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

import Buyer from './Buyer'
import SettingItem from './SettingItem'

import PaymentTools from '../../helpers/PaymentTools.js'
import PaymentForm from '../../components/Payment/PaymentForm'

import printUtil from '@/plugins/print';

import {APIService} from '@/APIService'
const apiService = new APIService()

export default {
    name: 'Cart',
    components: {
        Buyer,
        SettingItem,
        PaymentForm
    },
    data() {
        return {
            isDirectSale: false,
            menuPickupDate: false,
            pickup_date: this.$moment().format('YYYY-MM-DD'),
            press_register: false
        }
    },
    computed: {
        ...mapState('cash', [
            'cashCurrent'
        ]),
        ...mapState('sales', [
            'selectedProducts',
            'totalQuantity',
            'subtotal',
            'itemSelected',
            'buyer',
            'buyerId',
            'por_igv',
            'amount_igv',
            'total',
            'orderId',
            'discount',
            'total_bonus'
        ]),
        ...mapState('authentication', [
            'igv',
            'companyData'
        ]),
        ...mapState('payment', [
            'listProducts',
        ]),
        ...mapState('orders', [
            'order'
        ]),
    },
    methods: {
        ...mapMutations('sales', [
            'setShowProduct',
            'setProduct',
            'setItemSelected'    
        ]),
        ...mapActions('sales', [
            'selectProduct',
            'addQuantityProduct',
            'removeQuantityProduct',
            'runSetItemSelected',
            'registerOrder',
            'runSetPorIgv',
            'clearData',
            'deleteProductFromSale'
        ]),
        ...mapActions('payment', [
            'runSetListProducts',
            'runSetCustomer',
            'runSetOrderIdPay',
            'runSetSubtotal',
            'runSetTotal',
            'runSetAmountIgv',
            'setDeliverOrder'
        ]),
        ...mapActions('orders', [
            'selectOrder'
        ]),
        addItem(item) {
            this.setProduct(item)
            this.addQuantityProduct()
        },
        removeItem(item) {
            this.setProduct(item)
            this.removeQuantityProduct()
        },
        deleteProduct(item) {
            this.setProduct(item)
            this.deleteProductFromSale()
        },
        handleClickSettingItem(item) {
            this.runSetItemSelected(item)
            this.$refs.settingItem.showForm('Precios y descuentos de producto')
        },
        handleCreateOrder() {
            this.press_register = true;
            let validate = this.validateData()
            if(validate.error) {
                this.press_register = false;
                this.$notify({
                    group: 'foo',
                    type: 'error',
                    title: 'RESULTADO DE INGRESO DE PEDIDO',
                    text: validate.message
                })
            } else {
                let order = {
                    customer: this.buyer,
                    products: this.selectedProducts,
                    discount: this.discount,
                    subtotal: this.subtotal,
                    amount_igv: this.amount_igv,
                    total:  this.total,
                    direct_sale: 0,
                    type_order: 'order',
                    pickup_date: this.pickup_date,
                    total_gratuitas: this.total_bonus
                }
                apiService.createOrder(order).then( (response) => {
                    this.press_register = false;
                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        title: 'RESULTADO DE INGRESO DE PEDIDO',
                        text: 'El pedido se registró de manera exitosa!'
                    })
                    this.clearData();
                })
            }            
        },
        handleUpdateOrder() {
            let validate = this.validateData()
            if(validate.error) {
                this.$notify({
                    group: 'foo',
                    type: 'error',
                    title: 'RESULTADO DE INGRESO DE PEDIDO',
                    text: validate.message
                })
            } else {
                let order = {
                    order_id: this.orderId,
                    customer: this.buyer,
                    products: this.selectedProducts,
                    discount: this.discount,
                    subtotal: this.subtotal,
                    amount_igv: this.amount_igv,
                    total:  this.total,
                    pickup_date: this.pickup_date,
                    total_gratuitas: this.total_bonus
                }
                apiService.updateOrder(order).then( (response) => {
                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        title: 'RESULTADO DE ACTUALIZACIÓN DE PEDIDO',
                        text: 'El pedido se actualizó de manera exitosa!'
                    })
                    this.clearData()
                })
            }            
        },
        handlePay() {
            let validate = this.validateData()
            if (validate.error) {
                this.$notify({
                    group: 'foo',
                    type: 'error',
                    title: 'RESULTADO DE INGRESO DE PEDIDO',
                    text: validate.message
                })
            } else {
                let order = {
                    customer: this.buyer,
                    products: this.selectedProducts,
                    discount: this.discount,
                    subtotal: this.subtotal,
                    amount_igv: this.amount_igv,
                    total:  this.total,
                    direct_sale: 1,
                    type_order: 'direct_sale',
                    pickup_date: this.pickup_date,
                    total_gratuitas: this.total_bonus
                }
                this.prepareDataToPaymentForm(order);
            }            
        },
        validateData(){
            let error = false
            let message = ""
            if (this.buyer == null) {
                error = true
                message = "Debe seleccionar el cliente."
            }
            if (this.selectedProducts.length <= 0) {
                error = true
                message = "Debe seleccionar al menos un producto."
            }

            return {
                error,
                message
            }
        },
        verifyPermission(permission) {
            return this.$hasPermision(permission)
        },
        handleVerifyCash(value){
            if (value == true) {
                if (this.cashCurrent == null || this.cashCurrent == '') {
                    this.isDirectSale = false;
                    this.$refs.swithDirect.onChange();
                    this.$swal({
                        text: "Caja esta cerrada, no puede realizar venta directa.",
                        icon: "warning",
                        showCancelButton: false,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Aceptar"
                    });
                }
            }
        },
        prepareDataToPaymentForm (order) {
            this.selectOrder(order)
            this.runSetOrderIdPay(null)
            this.runSetSubtotal(this.subtotal)
            this.runSetAmountIgv(this.amount_igv)
            this.runSetTotal(this.total)
            this.runSetListProducts([])
            this.runSetListProducts(PaymentTools.prepareProductList('sales', this.selectedProducts))
            this.runSetCustomer(this.buyer)
            this.$refs.paymentForm.showForm()
        },
        handleCreateOrderWithPayment () {
            let validate = this.validateData();
            if(validate.error) {
                this.$notify({
                    group: 'foo',
                    type: 'error',
                    title: 'RESULTADO DE INGRESO DE PEDIDO',
                    text: validate.message
                })
            } else {
                if (this.cashCurrent == null || this.cashCurrent == '') {
                    this.$swal({
                        text: "Caja esta cerrada, no puede realizar pagos.",
                        type: "warning",
                        showCancelButton: false,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Aceptar"
                    });
                } else {
                    let order = {
                        customer: this.buyer,
                        products: this.selectedProducts,
                        discount: this.discount,
                        subtotal: this.subtotal,
                        amount_igv: this.amount_igv,
                        total:  this.total,
                        direct_sale: 0,
                        type_order: 'order_payment',
                        pickup_date: this.pickup_date,
                        total_gratuitas: this.total_bonus
                    }

                    this.prepareDataToPaymentForm(order);
                }
            }
        },
        printVoucher (sale, companyData) {
            let print = new printUtil()
            print.launch().then(() => {
                print.printTicketVenta(sale, companyData)
            });            
        }
    },
    mounted(){
        this.setDeliverOrder(false);
        this.runSetPorIgv(this.igv)
        if(this.orderId == 0) {
            this.clearData()
        }
    }

}
</script>

<style>
.cart-amount-subtotal{
    display: block;
    font-weight: bold;
    font-size: 1rem;
}
.cart-amount-igv{
    display: block;
    font-weight: bold;
    font-size: 1rem;
}

.cart-summary{
    border-bottom: 1px solid #86A0A6;
    min-height: 35px !important;
}

.label-summary {
    text-align: left !important;
}
</style>